import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px 0 40px 0;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 0;
  width: 170px;
`;

export const Tag = styled.div`
  display: flex;
  width: 72px;
  height: 25px;
  background: ${(props) => props.theme.colors.darkblue};
  color: ${(props) => props.theme.colors.white};
  margin: 0 15px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 12px;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.label`
  font-size: ${(props) => props.size || '12px'};
  color: ${(props) => props.color};
  font-weight: bold;
`;

export const Divisor = styled.div`
  width: 90%;
  height: 1px;
  background: ${(props) => props.theme.colors.label};
  margin: 0 0 10px 0;
`;
